import { AppBar, Divider, Drawer, Stack } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import NavigationBarLogo from "@/src/components/Navigation/NavigationBar/NavigationBarLogo";
import BurgerButton from "@/src/components/Navigation/BurgerButton/BurgerButton";
import React, { useState } from "react";
import IconButtonLegalbird from "@/src/components/legalbird/IconButtonLegalbird/IconButtonLegalbird";
import CloseIcon from "@mui/icons-material/Close";
import AuthenticatedNavigation from "@/src/components/Navigation/AuthenticatedNavigation/AuthenticatedNavigation";

type NavigationBarMobileAuthenticatedProps = {
  clickableLogo?: boolean;
};

export default function NavigationBarMobileAuthenticated({ clickableLogo }: NavigationBarMobileAuthenticatedProps) {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <>
      <AppBar sx={(theme) => ({ backgroundColor: theme.palette.background.default })} elevation={0}>
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <NavigationBarLogo clickableLogo={clickableLogo} />
          <BurgerButton onClick={() => setMobileNavOpen(true)} />
        </Toolbar>
      </AppBar>
      <Drawer
        anchor={"top"}
        open={mobileNavOpen}
        slotProps={{
          paper: {
            sx: {
              height: "100%",
            },
          },
        }}
      >
        <Stack sx={{ height: "100%" }}>
          <Stack sx={{ flexDirection: "row", justifyContent: "space-between", padding: "1rem" }}>
            <NavigationBarLogo clickableLogo={clickableLogo} />
            <IconButtonLegalbird label={"Schließen"} variant={"text"} color={"primary"} onClick={() => setMobileNavOpen(false)}>
              <CloseIcon />
            </IconButtonLegalbird>
          </Stack>
          <Divider />
          <AuthenticatedNavigation sx={{ padding: "1.5rem 1rem 0.5rem 1rem" }} onClose={() => setMobileNavOpen(false)} />
        </Stack>
      </Drawer>
    </>
  );
}
